const LOGO_IMAGE_MIMES = new Set(['image/jpeg', 'image/png', 'image/webp']);
const MAX_ORIGINAL_BYTES = 10 * 1024 * 1024;
const TARGET_SIZE = 192;

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) reject(new Error('Falha ao processar imagem.'));
      else resolve(blob);
    }, type, quality);
  });
}

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Arquivo de imagem inválido.'));
    };
    img.src = url;
  });
}

/**
 * Recorta ao centro em quadrado e redimensiona para 192×192 (ratio 1:1).
 * PNG/WebP mantêm transparência (saída PNG); JPEG permanece JPEG.
 */
export async function compressCompanyLogo(file) {
  if (!file || !(file instanceof Blob)) {
    throw new Error('Selecione uma imagem.');
  }
  if (!LOGO_IMAGE_MIMES.has(file.type)) {
    throw new Error('Formato não permitido. Use JPEG, PNG ou WebP.');
  }
  if (file.size > MAX_ORIGINAL_BYTES) {
    throw new Error('Imagem muito grande. Máximo 10MB.');
  }

  const preserveAlpha = file.type === 'image/png' || file.type === 'image/webp';
  const img = await loadImage(file);
  let w = img.naturalWidth || img.width;
  let h = img.naturalHeight || img.height;
  if (!w || !h) throw new Error('Dimensões da imagem inválidas.');

  const side = Math.min(w, h);
  const sx = Math.max(0, Math.floor((w - side) / 2));
  const sy = Math.max(0, Math.floor((h - side) / 2));

  const canvas = document.createElement('canvas');
  canvas.width = TARGET_SIZE;
  canvas.height = TARGET_SIZE;
  const ctx = canvas.getContext('2d', { alpha: true });
  ctx.clearRect(0, 0, TARGET_SIZE, TARGET_SIZE);
  ctx.drawImage(img, sx, sy, side, side, 0, 0, TARGET_SIZE, TARGET_SIZE);

  const outputMime = preserveAlpha ? 'image/png' : 'image/jpeg';
  const ext = preserveAlpha ? 'png' : 'jpg';
  const quality = preserveAlpha ? undefined : 0.9;
  const blob = await canvasToBlob(canvas, outputMime, quality);
  const baseName = String(file.name || 'logo').replace(/\.[^.]+$/i, '') || 'logo';
  return new File([blob], `${baseName}.${ext}`, { type: outputMime, lastModified: Date.now() });
}

export const COMPANY_LOGO_ACCEPT = 'image/jpeg,image/png,image/webp';
